module.exports = __webpack_public_path__ + "img/fr3.7efecd14.jpg";